module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAf0lEQVR42u3VsQ0AIAgAQfbfysmwsLfRBCNH8q3oNUZmRudaPx4AAAAAAAAAAAAAgFXJjIiSAJwCbA4GAAAAgL8ALiwDAAAAAAC+QQAAAAD4BeDWAHgFoOoiAAAAAAAAAAAAAAAAAAAAAAAAAAAAqAHoGgAAAAAAAAAAAAAATZuVPxaJg160CgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Tonga.png
// module id = 1gmT
// module chunks = 0 62 63